import React, { useContext } from 'react';
import { AuthContext } from '../../../context/AuthProvider';
import { useQuery } from 'react-query';
import Treatment from './../../Home/Treatment/Treatment';
import Apointment from './../../Apointment/Apointment';
import { Link } from 'react-router-dom';

const MyAppointment = () => {
    const { user } = useContext(AuthContext);

    const url = `https://denticare-server-sumonhasan55.vercel.app/bookings?email=${user?.email}`
    const { data: bookings = [] } = useQuery(
        {
            queryKey: ['bookings', user?.email],
            queryFn: async () => {
                const res = await fetch(url,{
                    headers:{
                        authorization: `bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                const data = await res.json();
                return data
            }
        }
    )
    return (
        <div className="">
            <h1 className='mb-5 text-3xl font-bold text-green-700'>My Apointments</h1>
            <div className="overflow-x-auto">
                <table className="table w-full">
                    {/* head*/}
                    <thead>
                        <tr>
                            <th></th>
                            <th>Patient Name</th>
                            <th>Treatment</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                       {
                        bookings.map((booking,i)=>
                            <tr
                            key={booking._id}>
                            <th>{i+1}</th>
                            <td>{booking.patient}</td>
                            <td>{booking.treatment}</td>
                            <td>{booking.appointmentDate}</td>
                            <td>{booking.slot}</td>
                            <td>
                                
                                   {
                                    booking.price && !booking.paid &&  <Link to={`/dashboard/payment/${booking._id}`}>
                                    <button
                                    className='btn btn-info text-white btn-sm'
                                    >Pay</button>
                                    </Link>

                                   }
                                    
                                {
                                     booking.price && booking.paid && <span className='text-green-500'>Paid</span>
                                }
                            </td>
                        </tr>
                            )
                       }
                       
                      
                    </tbody>
                </table>
            </div>

        </div>
    );
};

export default MyAppointment;